import { ClpProductInfo } from '@src/types/product-card';

type GetProductImageProps = {
  productInfo: ClpProductInfo;
  isBRRedesign: boolean;
};

const parseImageURL = (imageURL: string) => imageURL && `/${imageURL}`.replace('//', '/');

export const getProductImage = ({ productInfo, isBRRedesign }: GetProductImageProps) => {
  const {
    pristineImageUrl,
    url,
    zoomImages
  } = productInfo;

  const hiResImage = zoomImages?.p01ZoomImagePath || pristineImageUrl;

  return parseImageURL(isBRRedesign && hiResImage ? hiResImage : url);
};
